// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*===============================
  container
================================*/
body {
  font-family: "Jost", serif;
  touch-action: manipulation;
}

input::-ms-reveal,
input::-ms-clear {
  display: none;
}

ul {
  list-style: none;
}

.newContainer {
  width: 100%;
  max-width: 1920px;
  min-width: 0;
  margin: 0 auto;
}

.sideBar {
  width: 250px;
  border-right: 1px solid rgba(0, 0, 0, 0.1019607843);
}

.mainContent {
  width: 100%;
  min-width: 0;
  flex: 1 1;
  padding-left: 30px;
}

.setting-sidebar {
  width: 250px;
  border-right: 1px solid #e8e9eb;
  padding-right: 24px;
}

.sticky-setting-sidebar {
  position: sticky;
  top: 94px;
}

.detailProductDesTop .image img {
  width: 100% !important;
  height: auto !important;
}

/*===============================
  swiper setting
================================*/
.home-new-arrivals__swiper .swiper-slide,
.home-store-near__swiper .swiper-slide,
.popularProduct .swiper-slide {
  height: auto !important;
}

.home-store-near__swiper,
.home-store-near__swiper .swiper-wrapper {
  padding-bottom: 2px;
}

@media (hover: none) and (pointer: coarse) {
  .swiper-horizontal[data-product-rail=true] {
    touch-action: pan-y pinch-zoom;
    -webkit-user-select: none;
    user-select: none;
  }
  .swiper-horizontal[data-product-rail=true] img {
    -webkit-user-drag: none;
  }
}
.mui-date-picker-width > div:hover fieldset {
  border-color: #c4c4c4 !important;
}
.mui-date-picker-width input {
  font-family: "Jost", serif !important;
  padding-top: 0;
  padding-bottom: 0;
  border: none;
}

.deliveryDatePicker > div:hover fieldset {
  border-color: #c4c4c4 !important;
}
.deliveryDatePicker input {
  height: 34px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.deliveryRightSec .coupenTipRigh† {
  max-width: 100%;
}

.checkoutPayBtn {
  border: none;
  outline: none;
  background-color: #108910 !important;
  padding: 13px 46px !important;
  color: #fff !important;
  border-radius: 30px !important;
  cursor: pointer !important;
  white-space: nowrap;
  width: 100% !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  line-height: 1.5 !important;
}
.checkoutPayBtn:hover {
  background-color: #80b918 !important;
}
.checkoutPayBtn:disabled, .checkoutPayBtn.Mui-disabled {
  background-color: #ccc !important;
  cursor: not-allowed !important;
  opacity: 0.7;
}

.chooseTimeSelect .css-1jy569b-MuiFormLabel-root-MuiInputLabel-root {
  transform: translate(14px, 13px) scale(0.75);
  -webkit-transform: translate(14px, 13px) scale(0.75);
}
.chooseTimeSelect #demo-simple-select {
  padding: 11.5px 14px;
}

.loaderGig {
  height: calc(100vh - 150px);
  justify-content: center;
  display: flex;
  align-items: center;
}

/*===============================
  checkout
================================*/
.rightContainerCheckout {
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc(50% - 10px);
  width: 100%;
}
.rightContainerCheckout .coupenTipRigh† {
  width: 100%;
  max-width: 100%;
}

.deliveryRightSec {
  width: 100%;
  max-width: 100%;
}

.cardNumberPlaceholder::placeholder {
  color: #bfbfbf !important; /* Change to desired color */
  /* Optional: make it bold */
  font-size: 14px; /* Optional: change size */
  opacity: 1; /* Ensure it's visible */
}

.rowStyle {
  margin-bottom: 2rem;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(175px, 1fr));
  gap: 10px;
}
@media (max-width: 768px) {
  .rowStyle {
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  }
}

.cardStyle {
  height: 100%;
  display: flex;
  flex-direction: column;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.2s ease, transform 0.2s ease;
  overflow: hidden;
}
.cardStyle:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transform: translateY(-2px);
}

/*===============================
  media query
================================*/
@media (min-width: 769px) {
  .sideBar {
    width: 250px;
    border-right: 1px solid rgba(0, 0, 0, 0.1019607843);
    position: sticky;
    height: calc(100vh - 89px);
    top: 99px;
    left: 0;
    align-self: flex-start;
    overflow-y: auto;
    overflow-x: hidden;
    background-color: #fff; /* optional: background color */
    z-index: 1;
    /* width */
  }
  .sideBar.sideBarChangeValue {
    top: 141px;
    height: calc(100vh - 131px);
  }
  .sideBar::-webkit-scrollbar {
    width: 3px;
  }
  .sideBar {
    /* Track */
  }
  .sideBar::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px grey;
    border-radius: 10px;
    cursor: pointer;
  }
  .sideBar {
    /* Handle */
  }
  .sideBar::-webkit-scrollbar-thumb {
    background: #3e85f8;
    border-radius: 10px;
    cursor: pointer;
    -webkit-transition: background 0.3s ease-in-out;
    transition: background 0.3s ease-in-out;
    outline: 1px solid #fff;
  }
  .sideBar {
    /* Handle on hover */
  }
  .sideBar::-webkit-scrollbar-thumb:hover {
    background: #0a64f9;
    cursor: pointer !important;
  }
  .headerSticky {
    position: sticky;
    inset-block-start: 0px;
    z-index: 4;
    background: #fff;
  }
  .mainContent {
    max-width: calc(100% - 250px);
    min-width: 0;
    padding-right: 18px;
  }
  .newContainer.d-flex > .mainContent {
    max-width: none;
    min-width: 0;
    flex: 1 1;
  }
}
.scrollBar {
  /* Scrollbar (base) */
}
.scrollBar::-webkit-scrollbar {
  width: 4px; /* vertical scrollbar width */
  height: 8px; /* horizontal scrollbar height */
}
.scrollBar {
  /* Track */
}
.scrollBar::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;
  cursor: pointer;
}
.scrollBar {
  /* Handle */
}
.scrollBar::-webkit-scrollbar-thumb {
  background: #3e85f8;
  border-radius: 10px;
  cursor: pointer;
  -webkit-transition: background 0.3s ease-in-out;
  transition: background 0.3s ease-in-out;
  outline: 1px solid #fff;
}
.scrollBar {
  /* Handle on hover */
}
.scrollBar::-webkit-scrollbar-thumb:hover {
  background: #0a64f9;
  cursor: pointer !important;
}

.headerStickyNavy {
  z-index: 40;
  border-bottom: 1px solid #173657;
  background: #091e3a;
  box-shadow: 0 8px 24px rgba(7, 25, 49, 0.2);
}

@media (max-width: 768px) {
  .rightContainerCheckout {
    flex-basis: 100%;
  }
  .mainContent {
    max-width: 100%;
    padding-left: 16px;
    padding-right: 16px;
  }
  .deliveryDatePicker > div {
    padding-right: 0 !important;
  }
}
@media (max-width: 600px) {
  .sideBar {
    width: 90vw;
    border-right: 1px solid rgba(0, 0, 0, 0.1019607843);
    position: sticky;
    top: 30px;
    height: calc(100vh - 30px);
    left: 0;
    align-self: flex-start;
    overflow-y: auto;
    overflow-x: hidden;
    background-color: #fff;
    z-index: 1;
    padding-bottom: 30px;
  }
  .sideBar.sideBarChangeValue {
    top: 30px;
    height: calc(100vh - 30px);
  }
  .sideBar::-webkit-scrollbar {
    width: 3px;
  }
  .sideBar::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px grey;
    border-radius: 10px;
  }
  .sideBar::-webkit-scrollbar-thumb {
    background: #3e85f8;
    border-radius: 10px;
    -webkit-transition: background 0.3s ease-in-out;
    transition: background 0.3s ease-in-out;
    outline: 1px solid #fff;
  }
  .sideBar::-webkit-scrollbar-thumb:hover {
    background: #0a64f9;
  }
}
.px-18px {
  padding-left: 18px;
  padding-right: 18px;
}

.pxR-18px {
  padding-right: 18px;
}`, "",{"version":3,"sources":["webpack://./src/Styles/global.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;;iCAAA;AAGA;EACE,0BAAA;EACA,0BAAA;AAEF;;AAAA;;EAEE,aAAA;AAGF;;AAAA;EACE,gBAAA;AAGF;;AADA;EACE,WAAA;EACA,iBAAA;EACA,YAAA;EACA,cAAA;AAIF;;AADA;EACE,YAAA;EACA,mDAAA;AAIF;;AADA;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;AAIF;;AAFA;EACE,YAAA;EACA,+BAAA;EACA,mBAAA;AAKF;;AAMA;EACE,gBAAA;EACA,SAAA;AAHF;;AAOI;EACE,sBAAA;EACA,uBAAA;AAJN;;AAQA;;iCAAA;AAME;;;EACE,uBAAA;AANJ;;AASA;;EAEE,mBAAA;AANF;;AASA;EACE;IACE,8BAAA;IACA,yBAAA;IACA,iBAAA;EANF;EASA;IACE,uBAAA;EAPF;AACF;AAWE;EACE,gCAAA;AATJ;AAWE;EACE,qCAAA;EACA,cAAA;EACA,iBAAA;EACA,YAAA;AATJ;;AAmBI;EACE,gCAAA;AAhBN;AAmBE;EACE,YAAA;EACA,0BAAA;EACA,6BAAA;AAjBJ;;AAqBE;EACE,eAAA;AAlBJ;;AAqBA;EACE,YAAA;EACA,aAAA;EACA,oCAAA;EACA,6BAAA;EACA,sBAAA;EACA,8BAAA;EACA,0BAAA;EACA,mBAAA;EACA,sBAAA;EACA,0BAAA;EACA,2BAAA;EACA,2BAAA;AAlBF;AAoBE;EACE,oCAAA;AAlBJ;AAqBE;EAEE,iCAAA;EACA,8BAAA;EACA,YAAA;AApBJ;;AAwBE;EACE,4CAAA;EACA,oDAAA;AArBJ;AAuBE;EACE,oBAAA;AArBJ;;AAwBA;EACE,2BAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;AArBF;;AAwBA;;iCAAA;AAGA;EACE,YAAA;EACA,cAAA;EACA,4BAAA;EACA,WAAA;AArBF;AAsBE;EACE,WAAA;EACA,eAAA;AApBJ;;AAuBA;EACE,WAAA;EACA,eAAA;AApBF;;AAuBA;EACE,yBAAA,EAAA,4BAAA;EACA,2BAAA;EACA,eAAA,EAAA,0BAAA;EACA,UAAA,EAAA,wBAAA;AApBF;;AAuBA;EACE,mBAAA;EACA,aAAA;EACA,4DAAA;EACA,SAAA;AApBF;AAsBE;EANF;IAOI,4DAAA;EAnBF;AACF;;AAsBA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,wCAAA;EACA,qDACE;EAEF,gBAAA;AArBF;AAuBE;EACE,0CAAA;EACA,2BAAA;AArBJ;;AAyBA;;iCAAA;AAGA;EACE;IACE,YAAA;IAEA,mDAAA;IACA,gBAAA;IACA,0BAAA;IACA,SAAA;IAEA,OAAA;IACA,sBAAA;IACA,gBAAA;IACA,kBAAA;IACA,sBAAA,EAAA,+BAAA;IACA,UAAA;IACA,UAAA;EAxBF;EAyBE;IACE,UAAA;IACA,2BAAA;EAvBJ;EAyBE;IACE,UAAA;EAvBJ;EAGA;IAuBE,UAAA;EAvBF;EAwBE;IACE,8BAAA;IACA,mBAAA;IACA,eAAA;EAtBJ;EALA;IA8BE,WAAA;EAtBF;EAuBE;IACE,mBAAA;IACA,mBAAA;IACA,eAAA;IACA,+CAAA;IAAA,uCAAA;IACA,uBAAA;EArBJ;EAfA;IAuCE,oBAAA;EArBF;EAsBE;IACE,mBAAA;IACA,0BAAA;EApBJ;EAwBA;IACE,gBAAA;IACA,sBAAA;IACA,UAAA;IACA,gBAAA;EAtBF;EAwBA;IACE,6BAAA;IACA,YAAA;IACA,mBAAA;EAtBF;EAyBA;IACE,eAAA;IACA,YAAA;IACA,SAAA;EAvBF;AACF;AA0BA;EACE,qBAAA;AAxBF;AAyBE;EACE,UAAA,EAAA,6BAAA;EACA,WAAA,EAAA,gCAAA;AAvBJ;AAmBA;EAOE,UAAA;AAvBF;AAwBE;EACE,8BAAA;EACA,mBAAA;EACA,eAAA;AAtBJ;AAWA;EAcE,WAAA;AAtBF;AAuBE;EACE,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,+CAAA;EAAA,uCAAA;EACA,uBAAA;AArBJ;AACA;EAuBE,oBAAA;AArBF;AAsBE;EACE,mBAAA;EACA,0BAAA;AApBJ;;AAwBA;EACE,WAAA;EACA,gCAAA;EACA,mBAAA;EACA,2CAAA;AArBF;;AAwBA;EACE;IACE,gBAAA;EArBF;EAuBA;IACE,eAAA;IACA,kBAAA;IACA,mBAAA;EArBF;EAuBA;IACE,2BAAA;EArBF;AACF;AAuBA;EACE;IAEE,WAAA;IACA,mDAAA;IACA,gBAAA;IACA,SAAA;IACA,0BAAA;IACA,OAAA;IACA,sBAAA;IACA,gBAAA;IACA,kBAAA;IACA,sBAAA;IACA,UAAA;IACA,oBAAA;EAtBF;EAwBE;IACE,SAAA;IACA,0BAAA;EAtBJ;EAyBE;IACE,UAAA;EAvBJ;EA0BE;IACE,8BAAA;IACA,mBAAA;EAxBJ;EA2BE;IACE,mBAAA;IACA,mBAAA;IACA,+CAAA;IAAA,uCAAA;IACA,uBAAA;EAzBJ;EA4BE;IACE,mBAAA;EA1BJ;AACF;AA8BA;EACE,kBAAA;EACA,mBAAA;AA5BF;;AA8BA;EACE,mBAAA;AA3BF","sourcesContent":["/*===============================\r\n  container\r\n================================*/\r\nbody {\r\n  font-family: 'Jost', serif;\r\n  touch-action: manipulation;\r\n}\r\ninput::-ms-reveal,\r\ninput::-ms-clear {\r\n  display: none;\r\n}\r\n\r\nul {\r\n  list-style: none;\r\n}\r\n.newContainer {\r\n  width: 100%;\r\n  max-width: 1920px;\r\n  min-width: 0;\r\n  margin: 0 auto;\r\n  // padding-inline: 18px;\r\n}\r\n.sideBar {\r\n  width: 250px;\r\n  border-right: 1px solid #0000001a;\r\n}\r\n\r\n.mainContent {\r\n  width: 100%;\r\n  min-width: 0;\r\n  flex: 1;\r\n  padding-left: 30px;\r\n}\r\n.setting-sidebar {\r\n  width: 250px;\r\n  border-right: 1px solid #e8e9eb;\r\n  padding-right: 24px;\r\n  // .active{\r\n  //   background-color:#000;\r\n  //         span{\r\n  //       color:#fff;\r\n  //   }\r\n  //   img{\r\n  //       filter:invert(1);\r\n  //   }\r\n  // }\r\n}\r\n.sticky-setting-sidebar {\r\n  position: sticky;\r\n  top: 94px;\r\n}\r\n.detailProductDesTop {\r\n  .image {\r\n    img {\r\n      width: 100% !important;\r\n      height: auto !important;\r\n    }\r\n  }\r\n}\r\n/*===============================\r\n  swiper setting\r\n================================*/\r\n.home-new-arrivals__swiper,\r\n.home-store-near__swiper,\r\n.popularProduct {\r\n  .swiper-slide {\r\n    height: auto !important;\r\n  }\r\n}\r\n.home-store-near__swiper,\r\n.home-store-near__swiper .swiper-wrapper {\r\n  padding-bottom: 2px;\r\n}\r\n\r\n@media (hover: none) and (pointer: coarse) {\r\n  .swiper-horizontal[data-product-rail='true'] {\r\n    touch-action: pan-y pinch-zoom;\r\n    -webkit-user-select: none;\r\n    user-select: none;\r\n  }\r\n\r\n  .swiper-horizontal[data-product-rail='true'] img {\r\n    -webkit-user-drag: none;\r\n  }\r\n}\r\n\r\n.mui-date-picker-width {\r\n  > div:hover fieldset {\r\n    border-color: #c4c4c4 !important;\r\n  }\r\n  input {\r\n    font-family: 'Jost', serif !important;\r\n    padding-top: 0;\r\n    padding-bottom: 0;\r\n    border: none;\r\n    // font-size: 14px;\r\n    // color: #4A4A4A;\r\n    // &::placeholder {\r\n    //   color: #595959;\r\n    // }\r\n  }\r\n}\r\n.deliveryDatePicker {\r\n  > div:hover {\r\n    fieldset {\r\n      border-color: #c4c4c4 !important;\r\n    }\r\n  }\r\n  input {\r\n    height: 34px;\r\n    border-top-right-radius: 0;\r\n    border-bottom-right-radius: 0;\r\n  }\r\n}\r\n.deliveryRightSec {\r\n  .coupenTipRigh† {\r\n    max-width: 100%;\r\n  }\r\n}\r\n.checkoutPayBtn {\r\n  border: none;\r\n  outline: none;\r\n  background-color: #108910 !important;\r\n  padding: 13px 46px !important;\r\n  color: #fff !important;\r\n  border-radius: 30px !important;\r\n  cursor: pointer !important;\r\n  white-space: nowrap;\r\n  width: 100% !important;\r\n  font-size: 13px !important;\r\n  font-weight: 600 !important;\r\n  line-height: 1.5 !important;\r\n\r\n  &:hover {\r\n    background-color: #80b918 !important;\r\n  }\r\n\r\n  &:disabled,\r\n  &.Mui-disabled {\r\n    background-color: #ccc !important;\r\n    cursor: not-allowed !important;\r\n    opacity: 0.7;\r\n  }\r\n}\r\n.chooseTimeSelect {\r\n  .css-1jy569b-MuiFormLabel-root-MuiInputLabel-root {\r\n    transform: translate(14px, 13px) scale(0.75);\r\n    -webkit-transform: translate(14px, 13px) scale(0.75);\r\n  }\r\n  #demo-simple-select {\r\n    padding: 11.5px 14px;\r\n  }\r\n}\r\n.loaderGig {\r\n  height: calc(100vh - 150px);\r\n  justify-content: center;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n/*===============================\r\n  checkout\r\n================================*/\r\n.rightContainerCheckout {\r\n  flex-grow: 0;\r\n  flex-shrink: 0;\r\n  flex-basis: calc(50% - 10px);\r\n  width: 100%;\r\n  .coupenTipRigh† {\r\n    width: 100%;\r\n    max-width: 100%;\r\n  }\r\n}\r\n.deliveryRightSec {\r\n  width: 100%;\r\n  max-width: 100%;\r\n}\r\n\r\n.cardNumberPlaceholder::placeholder {\r\n  color: #bfbfbf !important; /* Change to desired color */\r\n  /* Optional: make it bold */\r\n  font-size: 14px; /* Optional: change size */\r\n  opacity: 1; /* Ensure it's visible */\r\n}\r\n\r\n.rowStyle {\r\n  margin-bottom: 2rem;\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(175px, 1fr));\r\n  gap: 10px;\r\n\r\n  @media (max-width: 768px) {\r\n    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));\r\n  }\r\n}\r\n\r\n.cardStyle {\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 8px;\r\n  background-color: #fff;\r\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\r\n  transition:\r\n    box-shadow 0.2s ease,\r\n    transform 0.2s ease;\r\n  overflow: hidden;\r\n\r\n  &:hover {\r\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\r\n    transform: translateY(-2px);\r\n  }\r\n}\r\n\r\n/*===============================\r\n  media query\r\n================================*/\r\n@media (min-width: 769px) {\r\n  .sideBar {\r\n    width: 250px;\r\n    // width: 90vw;\r\n    border-right: 1px solid #0000001a;\r\n    position: sticky;\r\n    height: calc(100vh - 89px);\r\n    top: 99px;\r\n\r\n    left: 0;\r\n    align-self: flex-start;\r\n    overflow-y: auto;\r\n    overflow-x: hidden;\r\n    background-color: #fff; /* optional: background color */\r\n    z-index: 1;\r\n    /* width */\r\n    &.sideBarChangeValue {\r\n      top: 141px;\r\n      height: calc(100vh - 131px);\r\n    }\r\n    &::-webkit-scrollbar {\r\n      width: 3px;\r\n    }\r\n\r\n    /* Track */\r\n    &::-webkit-scrollbar-track {\r\n      box-shadow: inset 0 0 5px grey;\r\n      border-radius: 10px;\r\n      cursor: pointer;\r\n    }\r\n\r\n    /* Handle */\r\n    &::-webkit-scrollbar-thumb {\r\n      background: #3e85f8;\r\n      border-radius: 10px;\r\n      cursor: pointer;\r\n      transition: background 0.3s ease-in-out;\r\n      outline: 1px solid #fff;\r\n    }\r\n\r\n    /* Handle on hover */\r\n    &::-webkit-scrollbar-thumb:hover {\r\n      background: #0a64f9;\r\n      cursor: pointer !important;\r\n    }\r\n  }\r\n\r\n  .headerSticky {\r\n    position: sticky;\r\n    inset-block-start: 0px;\r\n    z-index: 4;\r\n    background: #fff;\r\n  }\r\n  .mainContent {\r\n    max-width: calc(100% - 250px);\r\n    min-width: 0;\r\n    padding-right: 18px;\r\n  }\r\n\r\n  .newContainer.d-flex > .mainContent {\r\n    max-width: none;\r\n    min-width: 0;\r\n    flex: 1 1 0;\r\n  }\r\n}\r\n\r\n.scrollBar {\r\n  /* Scrollbar (base) */\r\n  &::-webkit-scrollbar {\r\n    width: 4px; /* vertical scrollbar width */\r\n    height: 8px; /* horizontal scrollbar height */\r\n  }\r\n\r\n  /* Track */\r\n  &::-webkit-scrollbar-track {\r\n    box-shadow: inset 0 0 5px grey;\r\n    border-radius: 10px;\r\n    cursor: pointer;\r\n  }\r\n\r\n  /* Handle */\r\n  &::-webkit-scrollbar-thumb {\r\n    background: #3e85f8;\r\n    border-radius: 10px;\r\n    cursor: pointer;\r\n    transition: background 0.3s ease-in-out;\r\n    outline: 1px solid #fff;\r\n  }\r\n\r\n  /* Handle on hover */\r\n  &::-webkit-scrollbar-thumb:hover {\r\n    background: #0a64f9;\r\n    cursor: pointer !important;\r\n  }\r\n}\r\n\r\n.headerStickyNavy {\r\n  z-index: 40;\r\n  border-bottom: 1px solid #173657;\r\n  background: #091e3a;\r\n  box-shadow: 0 8px 24px rgba(7, 25, 49, 0.2);\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .rightContainerCheckout {\r\n    flex-basis: 100%;\r\n  }\r\n  .mainContent {\r\n    max-width: 100%;\r\n    padding-left: 16px;\r\n    padding-right: 16px;\r\n  }\r\n  .deliveryDatePicker > div {\r\n    padding-right: 0 !important;\r\n  }\r\n}\r\n@media (max-width: 600px) {\r\n  .sideBar {\r\n    // width: 250px;\r\n    width: 90vw;\r\n    border-right: 1px solid #0000001a;\r\n    position: sticky;\r\n    top: 30px; // <-- FIXED: should match height calc below\r\n    height: calc(100vh - 30px); // <-- this + top should = 100vh\r\n    left: 0;\r\n    align-self: flex-start;\r\n    overflow-y: auto;\r\n    overflow-x: hidden;\r\n    background-color: #fff;\r\n    z-index: 1;\r\n    padding-bottom: 30px; // <-- ensures space for last item\r\n\r\n    &.sideBarChangeValue {\r\n      top: 30px; // <-- FIXED\r\n      height: calc(100vh - 30px); // <-- should match top\r\n    }\r\n\r\n    &::-webkit-scrollbar {\r\n      width: 3px;\r\n    }\r\n\r\n    &::-webkit-scrollbar-track {\r\n      box-shadow: inset 0 0 5px grey;\r\n      border-radius: 10px;\r\n    }\r\n\r\n    &::-webkit-scrollbar-thumb {\r\n      background: #3e85f8;\r\n      border-radius: 10px;\r\n      transition: background 0.3s ease-in-out;\r\n      outline: 1px solid #fff;\r\n    }\r\n\r\n    &::-webkit-scrollbar-thumb:hover {\r\n      background: #0a64f9;\r\n    }\r\n  }\r\n}\r\n\r\n.px-18px {\r\n  padding-left: 18px;\r\n  padding-right: 18px;\r\n}\r\n.pxR-18px {\r\n  padding-right: 18px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
